import { render, staticRenderFns } from "./AccountNeedsAttentionBanner.vue?vue&type=template&id=051d0d6a&scoped=true"
import script from "./AccountNeedsAttentionBanner.vue?vue&type=script&lang=js"
export * from "./AccountNeedsAttentionBanner.vue?vue&type=script&lang=js"
import style0 from "./AccountNeedsAttentionBanner.vue?vue&type=style&index=0&id=051d0d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051d0d6a",
  null
  
)

export default component.exports